module.exports = __webpack_public_path__ + "img/报寝.1a18208f.svg";